export const exceptAddress = [
    "/authentication/card/forgot-password"
]
